import { useState } from 'react';
import PropTypes from 'prop-types';
import useStyles from './styles';

import NavBar from './NavBar';
import TopBar from './TopBar';

function DashboardLayout({ children }) {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [isNavOpen, setNavOpen] = useState(true);

  return (
    <div className={classes.root}>
      <TopBar
        onMobileNavOpen={() => setMobileNavOpen(true)}
        openMenu={isNavOpen}
        setNavOpen={() => setNavOpen(!isNavOpen)}
      />

      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
        openMenu={isNavOpen}
      />

      <div className={classes[isNavOpen ? 'wrapper' : 'wrapperCollapsed']}>
        <div className={classes.contentContainer}>
          <div
            children={children}
            className={classes.content}
          />
        </div>
      </div>
    </div>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.any,
};

export default DashboardLayout;
